import styled from 'styled-components'
import { AddonGroupStyle } from '../AddonGroup/AddonGroupStyle'

export const AddonPageStyle = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 3em;
 
}

  .introText {
    font-size: 1.2em;
    max-width: 50em;
  }

  .footerText {
    font-size: 1.2em;
    max-width: 50em;
  }

  ${AddonGroupStyle} {
    margin-top: 1em;
    margin-bottom: 5em;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  }
`
